<div class="sidebar-header ">
  <h2>{{title}}</h2>
  
  <button class="close-sidebar" title="Close" (click)="sidebar.hide()" [disabled]="isUploadingDocument">
    <svg><use xlink:href="#icon-cancel"></use></svg>
  </button>
</div>

<div class="sidebar-content"> 
  <div class="select-file-upload">
    <label class="file-upload" [ngClass]="{'disabled': isUploadFileDisabled}"  (click)="selectFile()"><svg><use xlink:href="#icon-attach"></use></svg>Select File</label>
    <input #fileInput class="hidden" id="input-file-id" (change)="onNativeInputFileSelect($event)" type="file"/>
    <div class="document" [ngClass]="{'empty': !filesToUpload || filesToUpload.length === 0}">
      <ng-container *ngIf="filesToUpload && filesToUpload.length > 0">
        <app-doc-icon [fileName]="getFileName"></app-doc-icon>
        <span class="document-name">{{filesToUpload[0].name}}</span>
        <button class="remove-doc" title="Discard" (click)="filesToUpload=[]">
          <svg><use xlink:href="#icon-cancel"></use></svg>
        </button>
      </ng-container>

      <ng-container *ngIf="!filesToUpload || filesToUpload.length === 0">
        <span>No file selected</span>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="isLinkAllowed">
    <div class="separator">
      <span>or</span>
    </div>

    <div class="form-container" [ngClass]="{'disabled': isLinkDisabled }">
      <h6 class="label darken">Enter link to file</h6>
      <div class="input">
        <input type="text" [disabled]="isLinkDisabled" [(ngModel)]="linkAddress">
      </div>
    </div>
  </ng-container>
  <div class="form-container" *ngIf="libraryName == 'AccessTrends-Resources'">
      <h6 class="label font-12">Sort Order</h6>
      <div class="input">
        <input type="text" [(ngModel)]="sortOrder">
      </div>
    </div> 
  <ng-container *ngIf = "documentProperties?.length > 0">
    <ng-container *ngFor = "let p of documentProperties" [ngSwitch]="p.type">
      <div *ngIf="libraryName != 'AccessTrends-Resources'">
          <div class="form-container"  *ngSwitchCase="'CollateralType'" >
              <h6 class="label font-12">Collateral Type</h6>
              <div class="select">
                <ng-select [(ngModel)]="docItem[p.name]" [items]="referenceData?.CollateralTypes" bindLabel="Title" bindValue="Id" placeholder="Select an Option" [clearable]="false" appendTo="body"></ng-select>
              </div>
            </div>
      </div>

      <div class="form-container" *ngSwitchCase="'Keywords'">
        <h6 class="label font-12">{{p.caption}}</h6>
        <p class="sublabel">Add new keyword or pick from options</p>
        <div class="select">
          <ng-select [(ngModel)]="selectedKeywords" [items]="allKeyWords" bindLabel="Title" [multiple]="true" [closeOnSelect]="true" [hideSelected]="true" [addTag]="true" addTagText="Add keyword: " [openOnEnter] = "false" (add)="addKeyword($event)" (remove)="removeKeyword($event)" (clear)="clearKeywords()" [clearable]="false" appendTo="body"></ng-select>
        </div>
      </div>

      <div class="form-container" *ngSwitchCase="'Text'" >
        <h6 class="label font-12">{{p.caption}}</h6>
        <div class="textarea">
          <textarea [(ngModel)]="docItem[p.name]"></textarea>
        </div>
        <span class="sub-label">Remaining characters count: 50</span>
      </div>

      <div class="form-container" *ngSwitchCase="'string'" >
        <h6 class="label font-12">{{p.caption}}</h6>
        <div class="input">
          <input type="text" [(ngModel)]="docItem[p.name]">
        </div>
      </div>
    </ng-container>
  </ng-container>




  <div class="buttons-row" *ngIf="libraryName != 'AccessTrends-Resources'">
    <button class="submit-btn" type="button" [disabled]="isSubmitDisabled" (click)="submitDocument()">Submit</button>
  </div>
  <div class="buttons-row" *ngIf="libraryName == 'AccessTrends-Resources'">
      <button class="submit-btn" type="button" [disabled]="isSubmitDisabledforAccessTrends" (click)="submitDocument()">Submit</button>
    </div>

  <!--Uploading-->
  <div class="home-tabs-loader" *ngIf="isUploadingDocument">
    <div class="loader"></div>
    <p *ngIf="title !== 'Upload Guidance'">Uploading New Document...</p>
    <p *ngIf="title === 'Upload Guidance'">Uploading Guidance Document...</p>
  </div>
</div>
